module.exports = __webpack_public_path__ + "static/media/funds.682bbf9b.svg";